module.exports = __webpack_public_path__ + "img/hr-dry-hairy-tree-06.9605ae00.png";